"use client"
import React from 'react'

const DomainBulk = () => {
  return (
    <div className='custMargin'>
    <div className='container'>
      <p className='fs-4 textPara fw-normal' >
      Our streamlined bulk domain search feature allows you to search for the availability of multiple domain names globally,
continentally, or even by individual countries.<br/><br/>

We do not have a pre-set limit to the amount of domain names you can perform a bulk search on at any given time, however we recommend that you limit your bulk search to 50 domain names or less to ensure that domain availability results are returned in a quick and timely manner.
<br/><br/>
Our Bulk Search feature allows you to perform a Bulk Registrations of available domain names.


      </p>
    </div>
    </div>
  )
}

export default DomainBulk
